import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("统计")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-muted small" }
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_10 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_StatisticsView = _resolveComponent("StatisticsView")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "user_keyword",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.user_keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.user_keyword) = $event)),
                placeholder: "用户昵称/手机号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_series_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_series_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.card_series_id) = $event)),
                placeholder: "卡牌系列",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardSeriesOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_pool_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_pool_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.card_pool_id) = $event)),
                placeholder: "卡池",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardPoolOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "rarity",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.rarity,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.rarity) = $event)),
                placeholder: "稀有度",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rarityOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "is_guaranteed",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.is_guaranteed,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.is_guaranteed) = $event)),
                placeholder: "是否保底",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "是",
                    value: "true"
                  }),
                  _createVNode(_component_el_option, {
                    label: "否",
                    value: "false"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "date_range",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.date_range,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.date_range) = $event)),
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "info",
                onClick: _ctx.onViewStatistics
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          title: "用户",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(row.user.nickname), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(row.user.mobile), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "卡池",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.card_pool?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "抽中卡牌",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            (row.card)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (row.card.image)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: row.card.image,
                        "preview-src-list": [row.card.image],
                        fit: "cover",
                        style: {"width":"40px","height":"40px","margin-right":"8px"}
                      }, null, 8, ["src", "preview-src-list"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(row.card.name), 1),
                    _createVNode(_component_el_tag, {
                      type: _ctx.getRarityTagType(row.card.rarity),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.card.rarity_display || row.card.rarity), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "花费",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(" ¥" + _toDisplayString(row.price), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "体力",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.energy_cost), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "保底",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.is_guaranteed)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "否"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "第N抽",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.draw_count), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "抽卡时间",
          width: "160"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.statisticsDialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.statisticsDialogVisible) = $event)),
      title: "抽卡统计",
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_StatisticsView, { filters: _ctx.statisticsFilters }, null, 8, ["filters"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}